// Schema markup generators for different page types
export const generateOrganizationSchema = () => ({
  "@type": "Organization",
  "@id": "https://extraterrestrialtools.com/#organization",
  "name": "Extraterrestrial Tools",
  "url": "https://extraterrestrialtools.com/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://extraterrestrialtools.com/favicon.svg",
    "width": 512,
    "height": 512
  },
  "description": "Expert reviews of AI software, digital tools, and lifetime deals for creators and entrepreneurs.",
  "foundingDate": "2024",
  "founder": {
    "@type": "Person",
    "name": "Mathias Deppe",
    "jobTitle": "Video & Sales Strategist"
  }
});

export const generateWebSiteSchema = () => ({
  "@type": "WebSite",
  "@id": "https://extraterrestrialtools.com/#website",
  "url": "https://extraterrestrialtools.com/",
  "name": "Extraterrestrial Tools",
  "description": "Discover top AI software, productivity tools, and exclusive lifetime deals.",
  "publisher": {
    "@id": "https://extraterrestrialtools.com/#organization"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://extraterrestrialtools.com/search?q={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
});

export const generateReviewSchema = (review) => ({
  "@type": "Review",
  "name": `${review.title} Review`,
  "description": review.description,
  "itemReviewed": {
    "@type": "SoftwareApplication",
    "name": review.title.replace(" Review", ""),
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web, Windows, macOS, iOS, Android",
    "offers": {
      "@type": "Offer",
      "category": "Lifetime Deal",
      "url": review.affiliateLink
    }
  },
  "author": {
    "@type": "Person",
    "name": "Mathias Deppe"
  },
  "reviewRating": {
    "@type": "Rating",
    "ratingValue": review.rating,
    "bestRating": 5
  }
});

export const generateBreadcrumbSchema = (breadcrumbs) => ({
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": crumb.name,
    "item": crumb.url
  }))
});

export const generateCollectionPageSchema = (type, items, url) => ({
  "@type": "CollectionPage",
  "@id": url,
  "name": `${type} - Extraterrestrial Tools`,
  "description": `Browse the best AI software and productivity tool ${type.toLowerCase()} on Extraterrestrial Tools`,
  "url": url,
  "mainEntity": {
    "@type": "ItemList",
    "numberOfItems": items.length,
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "url": `https://extraterrestrialtools.com/#/${type.toLowerCase()}/${item.slug}`,
      "name": item.title
    }))
  }
});

export const generateHowToSchema = (tutorial) => ({
  "@type": "HowTo",
  "name": `How to use ${tutorial.tool}: ${tutorial.title}`,
  "description": tutorial.description,
  "step": [
    {
      "@type": "HowToStep",
      "name": "Introduction",
      "text": `Watch our tutorial on how to master ${tutorial.tool} for your business.`
    }
  ]
});

export const injectSchema = (schemaData) => {
  const existingSchema = document.querySelector('script[type="application/ld+json"]');
  if (existingSchema) {
    existingSchema.remove();
  }

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify({
    "@context": "https://schema.org",
    "@graph": Array.isArray(schemaData) ? schemaData : [schemaData]
  }, null, 2);
  
  document.head.appendChild(script);
};

export const generatePageSchema = (pageType, data = {}) => {
  const baseSchemas = [
    generateOrganizationSchema(),
    generateWebSiteSchema()
  ];

  switch (pageType) {
    case 'home':
      return [
        ...baseSchemas,
        generateBreadcrumbSchema([{ name: "Home", url: "https://extraterrestrialtools.com/" }])
      ];
    case 'reviews':
      return [
        ...baseSchemas,
        generateCollectionPageSchema('Reviews', data.reviews || [], 'https://extraterrestrialtools.com/#/reviews')
      ];
    case 'review':
      return [
        ...baseSchemas,
        generateReviewSchema(data.review)
      ];
    case 'tutorials':
      return [
        ...baseSchemas,
        generateCollectionPageSchema('Tutorials', data.tutorials || [], 'https://extraterrestrialtools.com/#/tutorials')
      ];
    case 'tutorial':
      return [
        ...baseSchemas,
        generateHowToSchema(data.tutorial)
      ];
    default:
      return baseSchemas;
  }
};